@if (datasetInfo$ | async; as datasets) {
  <main>
    <div
      id="help-panel"
      class="flex flex-column w-12 justify-content-center align-items-center"
    >
      <div
        class="flex flex-column w-11 lg:w-8 xl:w-6 justify-content-center align-content-center"
      >
        <h1>Datasets - Data to be validated and to be used as a reference</h1>
        <p class="text-primary mb-4">
          The following datasets can be validated within the QA4SM tool. These
          datasets are available in both the 'data' and the 'reference' sections
          and of the validate page. Click on the dataset name to get detailed
          information.
        </p>
      </div>
      <!-- Toggle open/close all -->
      <div
        class="flex flex-row flex-wrap w-11 justify-content-center align-items-center gap-2 pb-3"
      >
        <p-selectButton
          [options]="toggleOption"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="allSelected"
          (onChange)="onToggleAll(datasets)"
        >
        </p-selectButton>
      </div>
      <div
        class="flex flex-column w-11 lg:w-8 xl:w-6 justify-content-center align-content-center"
      >
        <!-- New API -->
        <p-accordion [multiple]="true" [(value)]="openPanels">
          @for (dataset of datasets; track dataset.id ?? dataset.pretty_name) {
            <p-accordion-panel [value]="panelKey(dataset)">
              <p-accordion-header>{{ dataset.pretty_name }}</p-accordion-header>
              <p-accordion-content>
                <div
                  class="flex flex-column w-12 align-content-center justify-content-center gap-3"
                >
                  <div class="flex flex-column text-justify w-12">
                    <h3>Description:</h3>
                    <div [innerHTML]="dataset.detailed_description"></div>
                    <div [innerHTML]="dataset.source_reference"></div>
                    <div>
                      Citation: <span [innerHTML]="dataset.citation"></span>
                    </div>
                    @if (dataset.not_as_reference) {
                      <div>
                        Please note that the dataset cannot be used as the
                        spatial reference for technical reasons.
                      </div>
                    }
                  </div>
                  <div class="flex flex-column text-justify w-12">
                    <h3>Filters:</h3>
                    <ol class="text-justify">
                      @for (
                        filter of dataset.filtersDescription;
                        track filter;
                        let ind = $index
                      ) {
                        <li class="ml-2">
                          {{ filter }}: {{ dataset.filtersHelpText[ind] }}
                        </li>
                      }
                    </ol>
                  </div>
                  <div class="flex flex-column text-justify w-12">
                    <h3>Supported versions with time range covered</h3>
                    <ul>
                      @for (
                        version of dataset.versions;
                        track version;
                        let ind = $index
                      ) {
                        <li class="ml-2">
                          <b>{{ version }}</b>
                          @if (
                            dataset.versionsHelpText[ind] !== "-" &&
                            dataset.versionsHelpText[ind] !== ""
                          ) {
                            <span>
                              ({{ dataset.versionsHelpText[ind] }}) <br />
                            </span>
                          }
                          <span>
                            Filters:
                            {{
                              getPositionsOfElementsInList(
                                dataset.filtersIds,
                                dataset.versionsFilters[ind]
                              ).replaceAll(",", ", ")
                            }}
                          </span>
                          <br />
                          @if (
                            dataset.versionsStart[ind] === "" &&
                            dataset.versionsEnd[ind] === ""
                          ) {
                            <span> Time coverage is station dependent </span>
                          } @else {
                            From: {{ dataset.versionsStart[ind] }} <br />
                            To: {{ dataset.versionsEnd[ind] }}
                          }
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>
    </div>
    <p-scrollTop styleClass="scroll-button"></p-scrollTop>
  </main>
}

@if (errorOccured) {
  <qa-error></qa-error>
}
